import { render, staticRenderFns } from "./profileSocMed.vue?vue&type=template&id=09a4ff98"
import script from "./profileSocMed.vue?vue&type=script&lang=js"
export * from "./profileSocMed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports